/**
 * Heading.jsx
 * ---------------------------------------------------------------------------
 * Typography primitives. H2 is the workhorse section headline (serif
 * display). Lede is the supporting paragraph beneath it.
 */

import React from "react";
import { tokens } from "../../lib/tokens.js";

export function H2({ children, style = {} }) {
  return (
    <h2
      style={{
        fontFamily: "'Cormorant Garamond', 'Times New Roman', serif",
        fontWeight: 400,
        fontSize: "clamp(32px, 4.2vw, 52px)",
        lineHeight: 1.08,
        letterSpacing: "-0.01em",
        color: tokens.ink,
        margin: 0,
        maxWidth: 820,
        ...style,
      }}
    >
      {children}
    </h2>
  );
}

export function Lede({ children, style = {} }) {
  return (
    <p
      style={{
        fontFamily: "'Inter', sans-serif",
        fontSize: 17,
        lineHeight: 1.65,
        color: tokens.inkSoft,
        maxWidth: 640,
        margin: "24px 0 0 0",
        fontWeight: 400,
        ...style,
      }}
    >
      {children}
    </p>
  );
}
